import CardWithTitle from 'components/atoms/CardWithTitle'
import PageTable from 'pages/CustomerManagement/InvoiceList/PageTable'
import React from 'react'

function RegistrationPage() {
  return (
    <CardWithTitle>
      <PageTable />
    </CardWithTitle>
  )
}

export default RegistrationPage
